import axios from "axios";

export const state = {
    packages: [],
};

export const getters = {
    packages: state => state.packages,
};

export const mutations = {
    setpackages(state, newValue) {
        state.packages = newValue
    },
};

export const actions = {
    fetchPackages({ commit }) {
        axios.get('/get_member_packages').then(res => {
            commit('setpackages', res.data.data)
        })
    },
};
